import React from "react";
import { type StringEnergy } from "../../hooks/useStringSpectrum";

interface Props {
  energies: StringEnergy[];
  expectedStrings?: number[]; // cuerdas que deberían sonar
}

export const StringSpectrum: React.FC<Props> = ({ energies, expectedStrings = [] }) => {
  return (
    <div className="flex items-end justify-center gap-2 h-16">
      {energies.map((e) => {
        const isExpected = expectedStrings.includes(e.string);
        const height = Math.max(4, e.value * 48);
        return (
          <div key={e.string} className="flex flex-col items-center gap-1">
            <div className="relative w-3 h-12 bg-[#E8E0D4] rounded-full overflow-hidden">
              <div
                className="absolute bottom-0 left-0 right-0 rounded-full transition-all duration-75"
                style={{
                  height: `${height}px`,
                  backgroundColor: isExpected
                    ? e.value > 0.15
                      ? "#10B981"
                      : "#EF4444"
                    : e.value > 0.15
                    ? "#F59E0B"
                    : "#D4C8B8",
                  opacity: e.value > 0.05 ? 0.9 : 0.3,
                }}
              />
            </div>
            <span className="text-[8px] font-bold text-[#8A8078] uppercase">{e.label}</span>
          </div>
        );
      })}
    </div>
  );
};
